export enum WaypointType {
  Point = 'point',
  Gate = 'gate',
}

export type Coordinate = [number, number];

// A point persists as a single coordinate, a gate as its two endpoints.
export type RouteWaypoint = {
  coordinates: Coordinate | Coordinate[];
};

export type RouteWaypointCoordinates = Coordinate | Coordinate[];

export type InputRoute = RouteWaypoint[];

export type NewRouteForm = {
  id?: number;
  name: string;
  route: RouteWaypoint[];
};

export type Route = {
  id: number;
  name: string;
  route: InputRoute;
};
